import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { toast } from "sonner";
import i18n from "@/i18n";
import BaseService from "./base.service";

export const getSWROption = (
  interval: number = 1000 * 60 * 60, // 1 hour
) => ({
  dedupingInterval: interval,
  errorRetryCount: 0,
  revalidateOnFocus: false,
  onError: (e: unknown) => {
    toast.error(i18n.t("errors.serverError"));
    console.error(e);
  },
});

export const defaultSWROption = getSWROption();

const ApiService = {
  fetchData<TReq, TRes>(
    config: AxiosRequestConfig<TReq>,
  ): Promise<AxiosResponse<TRes>> {
    return new Promise((resolve, reject) => {
      BaseService(config)
        .then((response: AxiosResponse<TRes>) => resolve(response))
        .catch((error: AxiosError) => reject(error));
    });
  },
};

export default ApiService;
